/**
 * 2WP Child Theme - Main JavaScript
 */

// Import main stylesheet so Vite emits dist/main.css.
// Block CSS/JS are built as separate entries and loaded conditionally by PHP.
import '../scss/main.scss';
import { initHeader } from './modules/header.js';
import { initWaves } from './modules/waves.js';
import { initReveal } from './modules/reveal.js';

/**
 * DOM Ready handler
 */
const ready = (fn) => {
  if (document.readyState !== 'loading') {
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
};

ready(() => {
  initHeader();
  initWaves();
  initReveal();
});

export { ready };
